module.exports = __webpack_public_path__ + "img/img10.65abfc4a.svg";